import { graphql } from "@/graphql/codegen"

import "./entityLock.fragment"

graphql(`
  query GetEntityLock($input: EntityLockInput!) {
    entityLock {
      get(input: $input) {
        ...EntityLockBaseFields
      }
    }
  }
`)
